// extracted by mini-css-extract-plugin
export default {"locationsList":"wLcg4nJdg9IsBrpAzdsj","name":"Der9rpVcPk_SATFT4TOR","address":"LhGftv_co6QUXnHk8IUt","editLink":"sUyeHIwCNrW2WSdAhEQA"};